import type { AccountApplicationContextType } from '@context/account-application/account-application-context';
import type { AccountApprovalContextType } from '@context/account-approval/account-approval-context';
import type { AccountForChildEligibilityDetails } from '@generated-types';

export interface ValidAccountApplicationContextType {
    selectedChildEligibility: AccountForChildEligibilityDetails;
    applicantParentEmail: string;
    notifyApproverParentOnPhoneNumber: string;
    applicantParentHasGivenConsent: true;
}

export const isValidAccountApplication = (
    context: AccountApplicationContextType,
): context is ValidAccountApplicationContextType =>
    !!context.selectedChildEligibility &&
    !!context.applicantParentEmail &&
    !!context.notifyApproverParentOnPhoneNumber &&
    !!context.selectedChildEligibility.currentBankCreateShareSavingsAccountEligibility.approverParent &&
    context.applicantParentHasGivenConsent;

interface ValidAccountApprovalContextType {
    approverParentEmail: string;
    approverParentHasGivenConsent: true;
}

export const isValidAccountApproval = (
    context: AccountApprovalContextType,
): context is ValidAccountApprovalContextType => !!context.approverParentEmail && context.approverParentHasGivenConsent;
